export default __webpack_public_path__ + "static/media/netflix-icon.0fce8fb1.svg";